(function(angular, module) {var TagServiceProvider, getResponseItem;

TagServiceProvider = function($q, $http, $location, $state, ApiUrl, TagNotificationService) {
  'ngInject';
  var deleteRequest, rootUrl;
  rootUrl = ApiUrl.partial('tag');
  this.getTagUrl = function() {
    var ref;
    return (ref = $state.current.data) != null ? ref.tagUrl : void 0;
  };
  this.hasUrlTags = function() {
    return this.getTagUrl() != null;
  };
  deleteRequest = function(url, data) {
    return $http({
      url: url,
      method: 'DELETE',
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  };
  this.getParamsFromUrl = function() {
    var params;
    params = $location.search();
    this.getTagUrl().addDefaults(params);
    return params;
  };
  this.lookupTags = function(params, root) {
    var url;
    url = root ? rootUrl(root, 'index') : rootUrl('index');
    return $http.get(url, {
      params: params
    }).then(function(response) {
      return response.data.items;
    });
  };
  this.paramsToUrl = function(params) {
    this.getTagUrl().addEmptyTags(params);
    $state.go('.', params, {
      location: 'replace'
    });
  };
  this.create = function(slug, name, description, program) {
    var data;
    data = {
      slug: slug,
      name: name,
      description: description,
      program_id: (program != null ? program.id : void 0) || program || void 0
    };
    return $http.post(rootUrl(), data).then(getResponseItem);
  };
  this.update = function(tag, name, description) {
    var data, tag_id, url;
    tag_id = tag.id || tag;
    url = rootUrl(tag_id);
    data = {
      name: name,
      description: description
    };
    return $http.patch(url, data).then(getResponseItem);
  };
  this.get = function(tagId) {
    return $http.get(rootUrl(tagId)).then(getResponseItem);
  };
  this["delete"] = function(tag) {
    var tag_id, url;
    tag_id = tag.id || tag;
    url = rootUrl(tag.id);
    return $http["delete"](url);
  };
  this.validateName = function(slug, name, program, existing) {
    var params, url;
    url = rootUrl(slug, 'available');
    params = {
      name: name,
      program_id: (program != null ? program.id : void 0) || program,
      tag_id: existing.id || existing
    };
    return $http.get(url, {
      params: params
    }).then(getResponseItem).then(function(tag) {
      if (tag && tag.id !== (existing.id || existing)) {
        return $q.reject(tag);
      } else {
        return tag;
      }
    });
  };
  this.getEntities = function(tag, params) {
    var url;
    if (params == null) {
      params = {};
    }
    url = rootUrl(tag.id, 'entities');
    return $http.get(url, {
      params: params
    });
  };
  this.getEntityCount = function(tag, params) {
    var url;
    if (params == null) {
      params = {};
    }
    url = rootUrl(tag.id, 'entities', 'count');
    return $http.get(url, {
      params: params
    }).then(function(r) {
      return r.data;
    });
  };
  this.setEntityTag = function(tag, entity, addTag) {
    if (addTag == null) {
      addTag = true;
    }
    if (addTag) {
      return this.tagEntity(tag, entity);
    } else {
      return this.untagEntity(tag, entity);
    }
  };
  this.tagEntity = function(tag, entity) {
    var entity_id, tag_id, url;
    tag_id = tag.id || tag;
    entity_id = entity.id || entity;
    url = rootUrl(tag_id, 'entities');
    return $http.post(url, {
      entity_id: entity_id
    }).then(TagNotificationService.addResponse);
  };
  this.tagFiltered = function(tag, filters) {
    var tag_id, url;
    tag_id = tag.id || tag;
    url = rootUrl(tag_id, 'entities');
    return $http.post(url, {
      filters: filters
    }).then(TagNotificationService.addResponse);
  };
  this.untagEntity = function(tag, entity) {
    var entity_id, tag_id, url;
    tag_id = tag.id || tag;
    entity_id = entity.id || entity;
    url = rootUrl(tag_id, 'entities');
    return deleteRequest(url, {
      entity_id: entity_id
    }).then(TagNotificationService.addResponse);
  };
  this.untagFiltered = function(tag, filters) {
    var tag_id, url;
    tag_id = tag.id || tag;
    url = rootUrl(tag_id, 'entities');
    return deleteRequest(url, {
      filters: filters
    }).then(TagNotificationService.addResponse);
  };
  return this;
};

getResponseItem = function(response) {
  return response.data.item;
};

module.factory('TagService', TagServiceProvider);
})(angular, angular.module("dybTags"));